import { Thead, Table } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { TableNew } from './indexNew';

export const TableHeading = styled(Thead)`
  color: white;
  font-weight: bold;
  background: #0f4f6d;


  th {
    text-transform: none;
    padding: 16px 16px; 
    position: sticky;
    top: 0;
    left: 0;
    background: #0f4f6d;
  }
`;

export const TableElement = styled(Table)`
  td,
  th {
    padding: 8px 16px;
  }
  tr {
    border-bottom: 1px solid #0f4f6d;
  }
`;
